import { PCheckboxWrapper } from '@porsche-design-system/components-react';
import { Form } from 'antd';
import { useField } from 'formik';
import { useCallback } from 'react';
import { type CheckboxFieldProps } from '../../../components/fields/CheckboxField';

const CheckboxField = (props: CheckboxFieldProps) => {
    const { name, required, label, itemProps, onChange: onChangeProps, checked, disabled, children, onClick } = props;
    const [{ onChange, ...fieldProps }, meta] = useField({ name, defaultChecked: checked });

    const onChangeHandler = useCallback(
        event => {
            if (onChangeProps) {
                onChangeProps(event);
            }

            onChange(event);
        },
        [onChange, onChangeProps]
    );

    return (
        <Form.Item {...itemProps} required={required}>
            <PCheckboxWrapper>
                <div slot="label">{label ?? children}</div>
                <input
                    {...fieldProps}
                    checked={fieldProps.value}
                    disabled={disabled}
                    onChange={onChangeHandler}
                    onClick={onClick}
                    type="checkbox"
                />
            </PCheckboxWrapper>
        </Form.Item>
    );
};

export default CheckboxField;
